import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { trackLead } from '../utils/metaPixel';
export function FloatingWhatsApp() {
  return <a href="https://wa.me/5212345678900" target="_blank" rel="noopener noreferrer" onClick={() => trackLead('floating-whatsapp')} className="fixed bottom-20 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 sm:bottom-24 sm:right-6 sm:h-16 sm:w-16" aria-label="Tengo dudas, pregúntame por WhatsApp" data-id="element-37" data-mp="6etkuo7oajau">
      <MessageCircleIcon className="h-7 w-7 sm:h-8 sm:w-8" data-id="element-38" data-mp="3ettw66ip1dbv" />
    </a>;
}